export enum GeneralApiEndpoints {
  LOGINWITHPASSWORD = '/loginWithPassword',
  BANNERS = '/banners',
  CUSTOMER_FEEDBACKS = '/feedbacks',
  LOGINWITHOTP = '/loginWithOtp',
  SENDOTP = '/sendOtp',
  UPDATE_PASSWORD = '/updatePassword',
  RESET_PASSWORD = '/resetPassword',
  FORGOT_PASSWORD = '/forgotPassword',
  SIGNUP = '/signup',
  PRODUCT_LIST = '/productList',
  CATEGORIES = '/categories',
  PRODUCT_INFO = '/product',
  DROPDOWN_OPTIONS = '/options',
  DASHBOARD = '/dashboard',
  ADD_PRODUCT_REVIEW = '/reviewProduct',
  GET_USER_PROFILE = '/getUserProfile',
  UPDATE_USER_ADDRESS = '/updateUserAddress',
  UPDATE_USER_PROFILE = '/updateUserProfile',
  UPLOAD_DOCUMENTS = '/uploadDocuments',
  DELETE_USER_ADDRESS = '/deleteAddress',
  UPDATE_CART = '/update-cart',
  REMOVE_CART_ITEM = '/remove-cart-item',
  GET_CART_ITEMS = '/cart-items',
  GET_CART_COUNT = '/cart-count',
  MERGE_CART = '/merge-cart',
  GET_BLOGS = '/blogs',
  GET_BLOGS_INFO = '/blogInfo',
  BLOG_LIST = '/blogs',
  GET_LOCAL_CART_SUMMARY = '/local-cart-summary',
  GET_CART_SUMMARY = '/cart-summary',
  CREATE_ORDER = '/create-order',
  PLACE_ORDER = '/place-order',
  GET_ORDERS = '/orders',
  GET_ORDER_DETAILS = '/order',
  FEATURED_CATEGORY_PRODUCTS = '/featured-category-products',
  UPDATE_FEEDBACK = '/update-feedback',
  CONTACT_US = '/contact-us',
  LOGIN_STATUS = '/login-status',
  SEARCH_SUGGESTIONS = '/search-suggestions',
  BRAND = '/brand',
  CANCEL_ORDER = '/cancel-order',
  STATES_LIST = '/states',
  CITIES_LIST = '/cities',
  CHECK_PINCODE = '/check-pincode',
  REVIEWS='/reviews',
  CHECKOUT_USER_FLOW='/checkout-user',
  CHECKOUT_USER_VERIFY='/checkout-user-verify',
  TRACKING='/track',
  FAQ='/faq'
}
